import { Fragment, isValidElement } from 'react'
import isFunction from 'lodash-es/isFunction'
import isObject from 'lodash-es/isObject'
import isString from 'lodash-es/isString'
import isUndefined from 'lodash-es/isUndefined'

const OBJECT_PROPS_TO_STRINGIFY = new Set(['style'])

function formatPropValue(value, key) {
  switch (true) {
    case isValidElement(value):
      return ['{', <Fragment key={key}>{value}</Fragment>, '}']
    case isString(value):
      return [JSON.stringify(value)]
    case isObject(value):
      return [
        '{',
        value.toJSON || OBJECT_PROPS_TO_STRINGIFY.has(key)
          ? JSON.stringify(value)
          : Object.prototype.toString.call(value),
        '}',
      ]
    case isUndefined(value):
      return ['{undefined}']
    default:
      return ['{', JSON.stringify(value), '}']
  }
}

/**
 * @param {Object} props
 * @returns {React.ReactNode[][]}
 */
export function formatProps(props) {
  return Object.keys(props)
    .sort()
    .reduce(
      (next, key) =>
        isFunction(props[key])
          ? next
          : [...next, [String(key), '=', ...formatPropValue(props[key], key)]],
      []
    )
}
